// extracted by mini-css-extract-plugin
export default {"homechef":"MillionsBanner-module_homechef_TRXoKNL79J","background":"MillionsBanner-module_background_oHvswICdpJ","millionsBanner":"MillionsBanner-module_millionsBanner_sm_MpX0coM"};